import React from "react";
import "../Header/Header.css";
import Navbar from "../Navbar/Navbar";
import personalPhoto from "../../assets/logos/wassim-personal-photo.jpeg";

function Header() {
  return (
    <>
      <div id="header" className="header-container">
        <div className="logo-container">
          <div className="logo-internal-container">
            <img src={personalPhoto} alt="Edu Boost Logo" />
          </div>
        </div>
        <div className="app-name">
          <h1>Wassim Mahmoud</h1>
        </div>
        <Navbar />
      </div>
    </>
  );
}

export default Header;
